/**
 * Utilities for parsing Algolia highlight results
 */

export interface AlgoliaHighlightResult {
  value?: string;
  [key: string]: unknown;
}

export function getHighlightedText(
  highlightResult: Record<string, AlgoliaHighlightResult> | null | undefined,
  field: string
): string | null {
  if (highlightResult && highlightResult[field] && highlightResult[field].value) {
    return highlightResult[field].value ?? null;
  }
  return null;
}

export function getHighlightedParts(text: string): Array<{ text: string; isHighlighted: boolean }> {
  const parts = text.split(/(<em>.*?<\/em>)/);

  return parts
    .map((part) => {
      if (part.startsWith("<em>") && part.endsWith("</em>")) {
        const highlightedText = part.replace(/<\/?em>/g, "");
        return { text: highlightedText, isHighlighted: true };
      }
      return { text: part, isHighlighted: false };
    })
    .filter((part) => part.text.length > 0);
}
